function initRzTimelineTabs() {
  const wrappers = document.querySelectorAll('[data-rz-tabs="wrapper"]');

  wrappers.forEach((wrapper) => {
    // Skip if already initialized
    if (wrapper.dataset.rzTabsInit === 'true') return;
    wrapper.dataset.rzTabsInit = 'true';

    const contentItems = wrapper.querySelectorAll('[data-rz-tabs="content-item"]');
    const visualItems = wrapper.querySelectorAll('[data-rz-tabs="visual-item"]');

    if (contentItems.length === 0 || visualItems.length === 0) return;

    const autoplay = wrapper.dataset.rzTabsAutoplay === 'true';
    const autoplayDuration = parseInt(wrapper.dataset.rzTabsAutoplayDuration) || 5000;

    let activeContent = null;
    let activeVisual = null;
    let isAnimating = false;
    let progressBarTween = null;

    function startProgressBar(index) {
      if (progressBarTween) progressBarTween.kill();
      const bar = contentItems[index].querySelector('[data-rz-tabs="item-progress"]');
      if (!bar) return;

      gsap.set(bar, { width: '0%' });
      progressBarTween = gsap.to(bar, {
        width: '100%',
        duration: autoplayDuration / 1000,
        ease: 'power1.inOut',
        onComplete: () => {
          if (!isAnimating) {
            const nextIndex = (index + 1) % contentItems.length;
            switchTab(nextIndex);
          }
        }
      });
    }

    function switchTab(index) {
      if (isAnimating || contentItems[index] === activeContent) return;

      isAnimating = true;
      if (progressBarTween) progressBarTween.kill();

      const outgoingContent = activeContent;
      const outgoingVisual = activeVisual;
      const outgoingBar = outgoingContent?.querySelector('[data-rz-tabs="item-progress"]');

      const incomingContent = contentItems[index];
      const incomingVisual = visualItems[index];
      const incomingBar = incomingContent.querySelector('[data-rz-tabs="item-progress"]');

      const tl = gsap.timeline({
        defaults: { duration: 0.65, ease: 'power3' },
        onComplete: () => {
          activeContent = incomingContent;
          activeVisual = incomingVisual;
          isAnimating = false;
          if (autoplay) startProgressBar(index);
        }
      });

      if (outgoingContent) {
        outgoingContent.classList.remove('active');
        outgoingVisual?.classList.remove('active');
        tl.to(outgoingBar, { width: '0%', duration: 0.3 }, 0)
          .to(outgoingVisual, { autoAlpha: 0, xPercent: 3 }, 0)
          .to(outgoingContent.querySelector('[data-rz-tabs="item-details"]'), { height: 0 }, 0);
      }

      incomingContent.classList.add('active');
      incomingVisual.classList.add('active');
      tl.fromTo(incomingVisual, { autoAlpha: 0, xPercent: 3 }, { autoAlpha: 1, xPercent: 0 }, 0.3)
        .fromTo(incomingContent.querySelector('[data-rz-tabs="item-details"]'), { height: 0 }, { height: 'auto' }, 0)
        .set(incomingBar, { width: '0%' }, 0);
    }

    // Initialize first tab
    switchTab(0);

    // Click handlers
    contentItems.forEach((item, i) =>
      item.addEventListener('click', (e) => {
        e.preventDefault();
        if (item === activeContent) return;
        switchTab(i);
      })
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRzTimelineTabs);
} else {
  initRzTimelineTabs();
}
